import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import DrawerController from "./drawer_controller";

// Connects to data-controller="ticket-drawer"
export class TicketDrawerController extends DrawerController {
  static targets = ["drawer", "content"];

  connect() {
    super.connect();
    this.slideIndex = 0;
    this.swiper = null;
  }

  open(event) {
    super.open();
    this.slideIndex = event.params.index;
    this.initializeSwiper();
  }

  close() {
    // 印刷で隠れないように display:none を打ち消す
    super.close((drawer) => {
      drawer.style.display = "";
      this.destroySwiper();
    });
  }

  initializeSwiper() {
    this.swiper = new Swiper(".js-ticket-sample-slider", {
      autoHeight: true,
      slidesPerView: 1,
      initialSlide: this.slideIndex,
      pagination: {
        el: ".js-ticket-sample-slider-pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".js-ticket-sample-slider-next",
        prevEl: ".js-ticket-sample-slider-prev",
      },
      // キーボード操作
      keyboard: {
        enabled: true,
      },
    });

    //スライダー切り替わり時スクロール位置を戻す
    this.swiper.on("slideChange", function () {
      $(".simplebar-content-wrapper").scrollTop(0);
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
      $(".simplebar-content-wrapper").scrollTop(0);
    }
  }
}

export class TicketDrawerButtonController extends Controller {
  static outlets = ["ticket-drawer"];

  open(event) {
    for (const drawer of this.ticketDrawerOutlets) drawer.open(event);
  }
}
